// store/modules/courses.js
const state = {
  courses: [],
  status: "idle", // 'loading', 'success', 'error'
  error: null,
}

const getters = {
  getCourses(state) {
    return state.courses
  },
  getStatus(state) {
    return state.status
  },
  getError(state) {
    return state.error
  },
}

const mutations = {
  setCourses(state, payload) {
    state.courses = payload
    state.status = "success"
    state.error = null
  },
  setStatus(state, payload) {
    state.status = payload
  },
  setError(state, payload) {
    state.error = payload
    state.status = "error"
  },
}

const actions = {
  /**
   * Commit fetched courses to the store.
   * @param {Function} commit
   * @param {Array} payload - Courses array
   */
  setCourses({ commit }, payload) {
    commit("setCourses", payload)
  },
  setStatus({ commit }, payload) {
    commit("setStatus", payload)
  },
  setError({ commit }, payload) {
    commit("setError", payload)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
